import { UploadFile } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormLabel, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useState } from "react";

import { parsePriceDeckCsv } from "../helpers/parsePriceDeckCsv";


export const NewPriceDeck = ({ setNewPriceDeckVisible }) => {
  
  // const dispatch = useDispatch();

  const [name, setName] = useState('New Price Deck');
  const [description, setDescription] = useState('');
  const [currency, setCurrency] = useState('cad');
  const [setData] = useState(null);

  return (
    <Dialog 
      open={true} 
      onClose={() => setNewPriceDeckVisible(false)}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle>New Price Deck</DialogTitle>
      <DialogContent style={{display: 'flex', flexDirection: 'column', overflow: 'hidden', width: '100%'}}>
        
        <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
          <TextField
            margin="normal"
            id="name"
            label="Price Deck Name"
            placeholder="New Price Deck"
            type="text"
            value={name}
            variant="outlined"
            fullWidth
            onChange={e => setName(e.target.value || "")}
          />
        </FormControl>
        
        <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
          <TextField
            margin="normal"
            id="description"
            label="Price Deck Description"
            placeholder="Description"
            type="text"
            multiline
            minRows={2}
            maxRows={5}
            value={description}
            variant="outlined"
            fullWidth
            onChange={e => setDescription(e.target.value || "")}
          />
        </FormControl>

        <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
          <FormLabel component="legend">Primary Currency</FormLabel>
          <ToggleButtonGroup
            value={currency}
            exclusive
            onChange={(e, v) => setCurrency(v)}
            style={{width: '100%', marginTop: 10}}
          >
            <ToggleButton value="cad" style={{width: '50%'}} color="primary">
              CAD
            </ToggleButton>
            <ToggleButton value="usd" style={{width: '50%'}} color="primary">
              USD
            </ToggleButton>
          </ToggleButtonGroup>
        </FormControl>

        <Button
          component="label"
          variant="outlined" 
          color="primary"
          startIcon={<UploadFile />}
          style={{marginTop: 40}}
        >
          Upload Price Deck Data
          <input
            type="file"
            accept=".csv"
            hidden
            onChange={e => handleUploadData(e.target.files, setData)}
          />
        </Button>

      </DialogContent>
      <DialogActions>
        <Button onClick={() => setNewPriceDeckVisible(false)} color="primary">
          Cancel
        </Button>
        <Button variant="contained" onClick={handleNewPriceDeck} color="primary" disabled={name?.length === 0}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );

  // FUNCTIONS
  async function handleUploadData(rawData, setData) {
    try {
      if (!rawData) return;

      await parsePriceDeckCsv(rawData, setData);
    } catch (error) {
      console.log(error);
    };
  };

  async function handleNewPriceDeck() {
    try {
    
      console.log('Adding new price deck ' + name);

      // dispatch(getPriceDecks());

      
    } catch (error) {
      console.log(error);
    };
  };

};